// Generate a uuidv4
var uuid = function uuid() {
  var _process, _process$env;
  // if this is a test environment, return a static string so that snapshots are consistent
  if (((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'test') {
    return 'canvas_mock_testid';
  }
  // if this is not a test environment, return the real uuid
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

export { uuid as default };
